'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Icon;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _colors = require('../styles/colors');

var _svgs = require('./svgs');

var _svgs2 = _interopRequireDefault(_svgs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Icon(props) {
  var icon = (0, _svgs2.default)(props.type);
  var styles = (0, _styles2.default)(props.color, props.scale * 24, props.background);

  return _react2.default.createElement(
    'svg',
    _extends({ xmlns: 'http://www.w3.org/2000/svg' }, styles, { viewBox: icon.viewBox, preserveAspectRatio: 'xMidYMid meet' }),
    icon.path
  );
}

Icon.propTypes = {
  type: _propTypes2.default.oneOf(Object.keys(_svgs.possibilities)).isRequired,
  color: _propTypes2.default.oneOf(Object.values(_colors.COLORS)),
  background: _propTypes2.default.oneOf(Object.values(_colors.COLORS).concat('')),
  /**
   * Icons start at 24x24px.  Use the scale to change their size.
   */
  scale: _propTypes2.default.number
};

Icon.defaultProps = {
  color: _colors.COLORS.GREY,
  scale: 1,
  background: ''
};


//////////////////
// WEBPACK FOOTER
// ./~/tanda-components/Icon/index.js
// module id = 684
// module chunks = 0